import useProduct from './useProduct';
import { ReactComponent as GoBoatLogo } from '../Assets/Icons/logo.svg';
import { ReactComponent as SaunaLogo } from '../Assets/Icons/logoSauna.svg';

const useLogo = () => {
  const product = useProduct();

  if (product === 'sauna') return SaunaLogo;

  return GoBoatLogo;
};

export default useLogo;
